exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clipboard[data-v-5beab80e]{display:inline-block;padding:0;border:none;background:none}.clipboard svg[data-v-5beab80e]{pointer-events:none;width:12px;height:12px}", ""]);

// exports
